module.exports = __webpack_public_path__ + "static/img/home_card.418b72eb.gif";